import { TimeStamp, TimeStampType } from "@src/common/TimeStamp";
import MainStore, { InteractionPointType } from "@src/model/Main.Store";
import * as yaml from "js-yaml";



export type Program = {
    title?: string,
    description?: string,
    main: {
        video_src: string,
        interact?: (
            { question: {
                around: TimeStampType,
                text: string
            } }
            | { select: {
                around: TimeStampType,
                text: string,
                choices: (
                    { label: string, text: string, goto: TimeStampType }
                )[]
            } }
        )[]
    }
}

function _FixChoice(x: any) {
    x.target = TimeStamp.fromString(x.target);
}

// {around:TimeStamp, ...[string]: any}
// --> {around:TimeStamp, type: InteractionPointType, ...[string]: any}
function _aux_FixInteract(x: any, fieldName: string) {
    for (const k in x[fieldName]) {
        if (Object.prototype.hasOwnProperty.call(x[fieldName], k)) {
            const v = x[fieldName][k];
            x[k] = v;
        }
    }
}

function _FixInteract(x: any) {
    x.around = TimeStamp.fromString(x.around);
    // TODO: this is not complete. finish this.
    if (x.info) {
        x.type = InteractionPointType.INFO;
        _aux_FixInteract(x, 'info');
        delete x.info;
    } else if (x.prompt) {
        x.type = InteractionPointType.PROMPT;
        _aux_FixInteract(x, 'prompt');
        delete x.prompt;
    } else if (x.choose) {
        x.type = InteractionPointType.CHOOSE;
        _aux_FixInteract(x, 'choose');
        if (x.choices) { x.choices.forEach((v) => _FixChoice(v)); }
        delete x.choose;
    }
    
}
function _FixMain(x: any) {
    if (x.interact) { x.interact.forEach((v) => _FixInteract(v)); }
}
function _Fix(x: string) {
    let res: any = yaml.load(x);
    if (res.main) { _FixMain(res.main); }
    return res;
}

export function LoadSource(x: string) {
    try {
        let fixed = _Fix(x);
        MainStore.setVideoSource(fixed.main.video_src);
        MainStore.getValue().currentInteractionPointList.set(fixed.main.interact);
    } catch (e) {
        // fail silently because we don't have to report every single fail...
    }

}

